module.exports = __webpack_public_path__ + "static/img/jia.1526ffb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jia.jpg
// module id = 5qxo
// module chunks = 1